import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Bug icon. Exported from Figma (Bombiix 2026). */
const BugIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M14 11.3333C14 13.9107 12.2091 16 10 16C7.79086 16 6 13.9107 6 11.3333M14 11.3333C14 8.756 12.2091 6.66667 10 6.66667M14 11.3333H16M6 11.3333C6 8.756 7.79086 6.66667 10 6.66667M6 11.3333H4M10 6.66667V11.6307M12.5827 7.33333C12.6375 7.12025 12.6667 6.89687 12.6667 6.66667C12.6667 5.19391 11.4728 4 10 4C8.52724 4 7.33333 5.19391 7.33333 6.66667C7.33333 6.89687 7.3625 7.12025 7.41735 7.33333M14 8.66667L15.3333 7.33333M14 14L15.3333 15.3333M6 8.66667L4.66667 7.33333M6 14L4.66667 15.3333M10 11.6307C10 11.8723 10.0657 12.1095 10.19 12.3167L12 15.3333M10 11.6307C10 11.8723 9.93432 12.1095 9.80999 12.3167L8 15.3333"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default BugIcon;
